<template>
  <div class="modal fade" id="modalChangePassword" role="dialog">
    <div class="modal-dialog">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
          <h2 class="certa first-title">Alteração de Senha.</h2>
        </div>

        <div class="modal-body">
          <form>
            <div class="form-group input-blue">
<!--              <label></label>-->
              <input v-model="changePassword.newPassword" type="password" class="form-control" name="newPassword" placeholder="Nova senha" required>
              <span v-if="!$v.changePassword.newPassword.minLength" class="error-msg-modal">A senha deve ter pelo menos 6 caracteres</span>
            </div>

            <div class="form-group input-blue">
<!--              <label></label>-->
              <input v-model="changePassword.confNewPassword" type="password" class="form-control" name="email" placeholder="Confirmação de senha" required>
              <span v-if="!$v.changePassword.confNewPassword.minLength" class="error-msg-modal">A senha deve ter pelo menos 6 caracteres</span>
              <span v-if="!$v.changePassword.confNewPassword.sameAsPassword && $v.changePassword.confNewPassword.$model.length >= 6" class="error-msg-modal">A confirmação de senha não corresponde com a nova senha</span>
            </div>

            <div class="form-group input-blue">
<!--              <label></label>-->
              <input v-model="changePassword.oldPassword" type="password" class="form-control" name="oldPassword" placeholder="Senha antiga" required>
              <span v-if="!$v.changePassword.oldPassword.minLength" class="error-msg-modal">A senha deve ter pelo menos 6 caracteres</span>
            </div>
          </form>
        </div>

        <div class="modal-footer offset-top-20">
          <button v-on:click="sendChangePassword()" :disabled="loadingChange" v-bind:class="{'disable': loadingChange}" type="submit" class="nunito btn-yellow-save">
            <span v-if="!loadingChange">Salvar</span>
            <div class="loading-btn" v-else>
              <div class="spinner-btn">
                <div class="rect1"></div>
                <div class="rect2"></div>
                <div class="rect3"></div>
                <div class="rect4"></div>
                <div class="rect5"></div>
              </div>
            </div>
          </button>
          <button v-on:click="closeModal()" class="nunito close-btn">Fechar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { CHANGE_PASSWORD } from "../../../urlConfig";
  import { REQUEST_SERVICE } from "../../../requestConfig";
  import { UTIL_SERVICE } from "../../../utils";
  import { required, minLength, sameAs } from 'vuelidate/lib/validators'

  export default {
    name: "modalChangePassword",
    data() {
      return {
        changePassword: {
          newPassword: '',
          confNewPassword: '',
          oldPassword: ''
        },
        error: {
          notEqual: ''
        },
        loadingChange: false
      }
    },
    methods: {
      closeModal() {
        $('#modalChangePassword').modal('toggle');
      },
      sendChangePassword() {
        if (!this.$v.changePassword.newPassword.$invalid && !this.$v.changePassword.oldPassword.$invalid && !this.$v.changePassword.confNewPassword.$invalid) {
          UTIL_SERVICE.console("DATA SEND:", this.changePassword);
          REQUEST_SERVICE.put(CHANGE_PASSWORD, this.changePassword).then((response) => {
            UTIL_SERVICE.console("RESULT CHANGE_PASSWORD:", response);

            $('#modalChangePassword').modal('toggle');
            $('.modal-backdrop').remove();

            swal("Aviso", "Senha atualizada com sucesso.", "success");

          }).catch((reason) => {
            $('#modalChangePassword').modal('toggle');
            $('.modal-backdrop').remove();

            reason.response.data.erros.map((value, index) => {
              swal("Aviso", value.value, "error");
            });
          });
        }
      }
    },
    validations: {
      changePassword:{
        newPassword: {
          required,
          minLength: minLength(6)
        },
        confNewPassword: {
          required,
          minLength: minLength(6),
          sameAsPassword: sameAs('newPassword')
        },
        oldPassword: {
          required,
          minLength: minLength(6)
        }
      }
    },
  }
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/vue/views/modals/modalChangePassword.vue